import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../../../../core/api/apiTypes"
import { ProductNumber, ProductNumberCreate, ProductNumberDetails, ProductNumberEdit } from "./productNumbersTypes"

export enum ProductNumbersQuery {
    LIST = "product-numbers-for-supplier",
    DETAILS = "details-for-product-numbers",
}

type DeleteProductNumberParam = Readonly<{
    id: number
}>

type FetchSupplierProductNumbersParam = Readonly<{
    supplierId: number
}>

type FetchSupplierProductNumbersResponse = Readonly<{
    productGroupNumbers: ProductNumber[]
}>

export type FetchDetailedProductNumberResponse = Readonly<{
    productGroupNumber: ProductNumberDetails
}>

type EditProductNumberParam = Readonly<{
    id: number
    productGroupNumber: ProductNumberEdit
}>

export async function deleteProductNumber(
    params: DeleteProductNumberParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { id } = params
    const url = `/productGroupNumbers/${id}`

    const response = await axios.delete(url, {
        signal,
    })

    return response.data
}

export async function fetchProductNumbers(
    { supplierId }: FetchSupplierProductNumbersParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSupplierProductNumbersResponse> {
    const url = `/suppliers/${supplierId}/erp/productGroupNumbers`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}

export async function createProductNumberApi(
    productGroupNumber: ProductNumberCreate,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = "/productGroupNumbers"

    const response = await axios.post(
        url,
        {
            productGroupNumber,
        },
        {
            signal,
        },
    )

    return response.data
}

export async function editProductApi(
    params: EditProductNumberParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { id, productGroupNumber } = params
    const url = `/productGroupNumbers/${id}`

    const response = await axios.post(
        url,
        {
            productGroupNumber,
        },
        {
            signal,
        },
    )
    return response.data
}

export async function fetchDetailedProductNumbers(
    params: { id: number },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchDetailedProductNumberResponse> {
    const { id } = params
    const url = `/productGroupNumbers/${id}`

    const response = await axios.get(url, {
        signal,
    })

    return response.data
}
